export default {
  black: '#000000',
  gray: '#8F8F8F',
  gray2: '#787878',
  white: '#FFFFFF',
}
